<!-- <app-sidebar></app-sidebar> -->
<!-- <app-hire-sidebar></app-hire-sidebar> -->
<!-- <app-navbar></app-navbar> -->
<router-outlet></router-outlet>
